export const CONTENT_UPLOAD_PUBLIC_BUCKET =
  process.env.REACT_APP_EXLY_S3_PUBLIC_CONTENT_BUCKET;

export const ATTACHMENT_UPLOAD_BUCKET =
  process.env.REACT_APP_S3_ATTACHMENT_BUCKET;
